const React = require("react");

function MenuAlt3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 12h16m-7 6h7"
  }));
}

module.exports = MenuAlt3Icon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/MenuAlt3Icon.js
 ** module id = 563
 ** module chunks = 0
 **/